'use strict';

// Import Libraries
import React from 'react';
import PropTypes from 'prop-types';
// Import JSX Modules
import Select from '../_utils/select-wrapper';
import defaultOptionValue from './_common/default-option-value';

// -----------------------------------------------------------
//  OptionSelector
// -----------------------------------------------------------
const OptionSelector = ({id, name, options, selected, onChange}) => {
  const selectOptions = options.map((option) => {
    return {
      label: option.name,
      value: option.value
    };
  });

  const handleChange = (value) => {
    onChange(id, value)
  };

  const optionValue = () => {
    return (selected && selected.value) || defaultOptionValue(options);
  };

  return (
      <div className="filter">
        <h2 className="h4">{ name }</h2>
        <Select options={ selectOptions }
                value={ optionValue() }
                onChange={ handleChange } />
      </div>
  );
};

OptionSelector.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  name: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.string,
      is_default: PropTypes.bool
    })
  ).isRequired,
  selected: PropTypes.shape({
    value: PropTypes.string,
    asset: PropTypes.string
  }),
  onChange: PropTypes.func.isRequired
};

export default OptionSelector;
